import React, { Fragment, useEffect, useState } from 'react'
import DashboardHeader from '../Common/DashboardHeader'
import { Link, useLocation } from 'react-router-dom'
import { ApproveCustomerApi, BusinessTypeApi, DetailsApi, RejectCustomerApi, UpdateBusinessTypeApi, getAgreementData, getEntityDetailsApi, getRejectedHistory, getSIPSellerData, verifyBankDetails } from '../../services/redux/ApiActions';
import { useDispatch, useSelector } from 'react-redux';
import showNotification from '../../services/redux/NotifcationService';
import { Transition } from '@headlessui/react';
import LogoDiv from '../Common/LogoDiv';
import logo from '../../img/BBPS_Horizontal.png';

const Details = (props) => {
    const location = useLocation();
    const [details, setDetails] = useState()
    const [businessTypes, setBusinessTypes] = useState()
    const { item } = location.state || {};
    const { type } = location.state || {};
    const loginData = useSelector((state) => state.login.loginData);
    const userAgent = window.navigator.userAgent;
    // Extract company details from the GSTIN response
    const gstinResponse = details?.result.gstinResponse;
    const gstin = details?.result.gstin;
    const businessType = details?.result.businessType;
    const pan = details?.result.pan;
    const panStatus = details?.result.panStatus;
    const panResponse = details?.result.panResponse;
    const panDetails = panResponse ? JSON.parse(panResponse) : null;
    const panLastName = panDetails?.lastName;
    const customerName = details?.result.customerName;
    const hdfcrm = details?.result.hdfcrm;
    const v2PRMEmail = details?.result.v2PRMEmail;
    const customerEmail = details?.result.email;
    const customerPhone = details?.result.phone;
    const customerBank = details?.result.partnerBankName;
    const customerProgram = details?.result.program;
    const gstinDetails = gstinResponse ? JSON.parse(gstinResponse) : null;
    // Now you can access specific properties from gstinDetails
    const tradeName = gstinDetails?.TradeName;
    const legalName = gstinDetails?.LegalName;
    const address = gstinDetails?.FullAddress;
    const gstinStatus = gstinDetails?.GSTINStatus;
    const [selectedBusinessType, setSelectedBusinessType] = useState('');
    const [rejectReason, setRejectedReason] = useState();
    const [rejectionEntries, setRejectionEntries] = useState();
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [businessTypeId, setBusinessTypeId] = useState()
    const containsProprietor = businessType?.toLowerCase().includes("proprietor");
    const containsPartner = businessType?.toLowerCase().includes("partner");
    const doesNotContainsLiability = !businessType?.toLowerCase().includes("liability");
    const containsHindu = businessType?.toLowerCase().includes("hindu");
    const containsLLP = businessType?.toLowerCase().includes("liability");
    const containsPublic = businessType?.toLowerCase().includes("public");
    const containsPrivate = businessType?.toLowerCase().includes("private");
    const containsSociety = businessType?.toLowerCase().includes("society");
    const [isSuccess,setIsSuccess]=useState(false)
    const [isErrorMsg,setErrorMsg]=useState(false)
    const [entityData, setEntityData] = useState()
    const [showB2BIds,setShowB2BIds]=useState(false)
    const [showSellerSelect,setShowSellerSelect]=useState(false)
    const [sellerData,setSellerData]=useState()
    const [selectedSeller, setSelectedSeller] = useState('');

    const dispatch = useDispatch()


    useEffect(() => {
        getDetails();
        getEntityDetails();
        getBusinessTypes();
        getRejectionData();
    }, [])
    const handleChange = (event) => {
        const selectedId = event.target.value;
        if (selectedId !== '') {
            const selectedBusiness = businessTypes.find((type) => type.id === parseInt(selectedId, 10));

            setSelectedBusinessType(selectedBusiness.id);
            // console.log(selectedBusiness.id)
            updateBusinessTypes(selectedBusiness.id);
        } else {
            showNotification('Please select a valid business type', 'error')
        }
        // You can do additional handling or state updates here if needed
    };

const handleSellerChange = (event) => {
    const selectedId=event.target.value;
    // setSelectedSeller(event.target.value);
            if (selectedId !== '') {
            const selectedSeller = sellerData.find((type) => type.sellerId === parseInt(selectedId, 10));

            setSelectedSeller(selectedSeller.sellerId);
        } else {
            showNotification('Please select a valid Seller', 'error')
        }
};

    const handleChangeRejectReason = (event) => {
        // Update the state with the selected value
        setRejectedReason(event.target.value);
    };
    const getDetails = async () => {
        // console.log(userAgent)
        const Payload = {
            "id": item.id
        }
        // console.log(Payload)
        const data = await dispatch(DetailsApi(Payload, loginData.token_chr));
        setDetails(data)
                if(data?.result.programId===34||data?.result.programId===35){
                setShowB2BIds(false);
                }else{
                setShowB2BIds(true);
                }
                if(data?.result.programId===35){
                     const sellerData = await dispatch(getSIPSellerData(loginData.token_chr));
                     setSellerData(sellerData.result);
                    setShowSellerSelect(true)
                }
        // console.log(data)
        setBusinessTypeId(data?.result.businessTypeId)
    }
    const getBusinessTypes = async () => {
        // console.log(userAgent)
        const Payload = {
            "id": 0
        }
        //console.log(Payload)
        const data = await dispatch(BusinessTypeApi(Payload, loginData.token_chr));
        setBusinessTypes(data?.result)

    }

    const getAgreementDataCall = async () => {
        const payload = {
            "customerId": item.id,
            "agreementReceivedBy": loginData.userId,
            "agreementReceivedIp": "",
            "agreementReceivedUserAgent": ""
        }
        const data = await dispatch(getAgreementData(payload, loginData.token_chr));
        if (data) {
            getDetails();
        } else {
            showNotification('Something Went Wrong', 'error')
        }
    }

    const getRejectionData = async () => {
        const payload = {
            "filter": `CustomerId==${item.id}`,
            "orderBy": "",
            "pageSize": 99999,
            "pageNumber": 1
        }
        const data = await dispatch(getRejectedHistory(payload, loginData.token_chr));
        if (data) {
            setRejectionEntries(data.result)
        } else {
            showNotification('Something Went Wrong', 'error')
        }
    }
    const updateBusinessTypes = async (id) => {
        //console.log(userAgent)
        const Payload = {
            "customerId": item.id,
            "businessTypeId": id
        }
        // console.log(Payload)
        if (await id) {
            const data = await dispatch(UpdateBusinessTypeApi(Payload, loginData.token_chr));
            getDetails();
            getBusinessTypes();
        }
    }
    const rejectCustomer = async (event) => {
        event.preventDefault();
        //console.log(userAgent)
        const Payload = {
            "customerId": item.id,
            "rejectionReason": rejectReason,
            "rejectedBy": loginData.userId,
            "rejectedIp": "",
            "rejectedUserAgent": userAgent
        }
        if (selectedBusinessType !== null || selectedBusinessType !== '') {
            const data = await dispatch(RejectCustomerApi(Payload, loginData.token_chr));
            if (data) {
                getRejectionData();
                getDetails()
                getBusinessTypes();
                setIsModalOpen(false);
            }
        } else {
            showNotification('Please select Business Type to proceed', 'warning')

        }

    }
    const handleApprove = () => {
        // Display a confirmation alert
        // console.log(selectedBusinessType)
        if (handleInitialBusinessTypeValue() !== '') {
            // If user confirms, make the API call
            const userConfirmed = window.confirm('Are you sure you want to approve this customer?');
            if (userConfirmed) {
                // Your API call logic goes here
                //    console.log('API call to approve');
                approveCustomer();
            }
        } else {
            showNotification('Please select Business Type to proceed', 'error')
        }

    };
    const approveCustomer = async () => {
        // console.log(userAgent)
        const Payload = {
            "customerId": item.id,
            "approvedBy": loginData.userId,
            "approvedByIp": "",
            "approvedByUserAgent": userAgent,
            "SellerId":showSellerSelect?selectedSeller:0
        }
        // console.log(Payload)
        const data = await dispatch(ApproveCustomerApi(Payload, loginData.token_chr));
        if (data) {
            showNotification(data.result, 'success');
            getDetails();
            getBusinessTypes();
            getRejectedHistory();
        }
    }

    function formatDate(dateString) {
        const date = new Date(dateString);

        // Array of month names
        const months = [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];

        // Get the month, day, year, hours, and minutes
        const month = months[date.getMonth()];
        const day = date.getDate();
        const year = date.getFullYear();
        const hours = date.getHours() % 12 || 12;
        const minutes = date.getMinutes();
        const period = date.getHours() < 12 ? "AM" : "PM";

        // Construct the formatted date string
        const formattedDate = `${day}-${month}-${year}`;

        return formattedDate;
    }

    const handleRejection = () => {
        // console.log(businessTypeId)
        if (selectedBusinessType !== '' || businessTypeId !== '') {
            setIsModalOpen(true)
        } else {
            showNotification('Please select Business Type to proceed', 'error')
        }
    }

    const findBusinessTypeId = (businessTypes, businessType) => {
        const foundType = businessTypes?.find(type => type.name === businessType);
        return foundType ? foundType.id : null;
    };

    function handleInitialBusinessTypeValue() {
        if (type === 'pending') {
            if (details?.result.businessTypeId === 0 || details?.result.businessTypeId === null) {
                const businessTypeId = findBusinessTypeId(businessTypes, businessType);
                // console.log(businessTypeId)
                updateBusinessTypes(businessTypeId)
                return businessTypeId;
            }
        }
        return details?.result.businessTypeId
    }

    let title = '';
    const handleTitle = () => {
        if (containsSociety && containsLLP && containsPublic && containsPrivate && containsHindu) {
            return title = 'List of Directors'
        }
        if (containsProprietor) {
            return title = 'Proprietor Details'
        }
    }

const accountNumber = details?.result?.customerBankDetails?.accountNumber;

const maskedAccount = accountNumber
  ? '**** ' + accountNumber.slice(-4)
  : 'Account not available';


    const VerifyBankDetails =async (details) => {
        // console.log(data?.accountType)
 
            let Data = {
                accountNumber: details?.result?.customerBankDetails?.accountNumber,
                ifsc: details?.result?.customerBankDetails?.ifsc,
                tradeName: tradeName,
                legalName: legalName,
                customerId: details?.result?.customerBankDetails?.customerId,
                MaxApiHitLimit: 20,
                gstin: details?.result?.gstin,
                accountName:details?.result?.customerBankDetails?.accountName
            }
            console.log(gstinResponse)
                const res = await dispatch(verifyBankDetails(Data, loginData.token_chr));
                        if (res === null) {
                            showNotification('Something went wrong','error')
                        }
                        if (
                            res?.responseCode === 'KPY00' &&
                            res?.accountVerificationStatus !== 'Unverified'
                        ) {
                           showNotification('Account is Verified','success')
                        }
                        if (
                            res?.responseCode === 'KPY00' &&
                            res?.accountVerificationStatus === 'Unverified'
                        ) {
                            if (
                                res?.beneficiaryName !== legalName ||
                                tradeName
                            ) {
                                showNotification("Benificiary Name doesn't match with Vendor's trader name or legal name","error")
                            }
                        }
                        if (res?.responseCode !== 'KPY00') {
                            showNotification("Benificiary Account cannot be verified","error")
                        } 
                        getDetails()
    }

 const getEntityDetails = async () => {
        const res = await dispatch(getEntityDetailsApi(item?.id, loginData.token_chr));
        if (res?.result) {
            setEntityData(res?.result);
            if (res?.result?.status !== 'Wait') {
                setIsSuccess(true)
            }
             if(res?.result?.status==='Failure'){
                setErrorMsg(true)
            }else{
            }
        }
    };

    return (
        <>
            <body className='mailsentbody'>
                <LogoDiv className='logoBG' >
                    <div className="rightElement">
                        <DashboardHeader />
                        <div className="grid mt-6 grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-1 lg:col-span-1"></div>
                            <div className="col-span-12 md:col-span-10 lg:col-span-10 ">
                                <div className="flex items-center justify-between mt-2 p-2 mx-4">
                                    <div className="col-span-6">
                                        <h1 className="text-3xl ">Customer Details</h1>
                                    </div>
                                    <div className="col-span-6 text-right">
                                        <button className="px-4 py-2 border border-sky-700 text-sky-700 rounded hover:bg-sky-700 hover:text-white" data-toggle="modal"
                                        >
                                            <Link to="/mailSent">Back to list</Link>
                                        </button>
                                    </div>

                                </div>
{showB2BIds&&(
                                    <div style={{display:'flex',justifyContent:'right',padding:'5px'}}>
  <img src={logo} width={"100px"} height={"100px"}/>
</div>
)}
                                <div className='bg-white mx-2 shadow-lg p-6 mt-4 rounded-lg'>
                                    <h2 className="text-center text-xl ">Details Entered By Staff</h2>
                                    <div className="overflow-x-auto mt-4 border rounded-md shadow-sm shadow-sm">
                                        <table style={{ minWidth: '100%', maxWidth: '5xl', backgroundColor: '#fff', borderCollapse: 'collapse', borderRadius: '0.375rem', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)' }}>
                                            <thead style={{ backgroundColor: '#718096' }}>
                                                <tr>
                                                    <th style={{ padding: '0.75rem', textAlign: 'left', fontSize: '0.75rem', fontWeight: 'medium', color: 'white', textTransform: 'uppercase', }}>
                                                        Company Name
                                                    </th>
                                                    <th style={{ padding: '0.75rem', textAlign: 'left', fontSize: '0.75rem', fontWeight: 'medium', color: 'white', textTransform: 'uppercase', }}>
                                                        Email
                                                    </th>
                                                    <th style={{ padding: '0.75rem', textAlign: 'left', fontSize: '0.75rem', fontWeight: 'medium', color: 'white', textTransform: 'uppercase', }}>
                                                        Phone
                                                    </th>
                                                    <th style={{ padding: '0.75rem', textAlign: 'left', fontSize: '0.75rem', fontWeight: 'medium', color: 'white', textTransform: 'uppercase', }}>
                                                        Partner Bank
                                                    </th>
                                                    <th style={{ padding: '0.75rem', textAlign: 'left', fontSize: '0.75rem', fontWeight: 'medium', color: 'white', textTransform: 'uppercase', }}>
                                                        Program
                                                    </th>
                                                    <th style={{ padding: '0.75rem', textAlign: 'left', fontSize: '0.75rem', fontWeight: 'medium', color: 'white', textTransform: 'uppercase', }}>
                                                        V2P RM
                                                    </th>
                                                    <th style={{ padding: '0.75rem', textAlign: 'left', fontSize: '0.75rem', fontWeight: 'medium', color: 'white', textTransform: 'uppercase', }}>
                                                        HDFC RM
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody style={{ backgroundColor: '#fff', borderBottom: '1px solid #ddd' }}>
                                                <tr style={{ borderTop: '1px solid #ddd' }}>
                                                    <td style={{ padding: '0.375rem', fontSize: '0.875rem', borderBottom: '1px solid #ddd' }}>{customerName}</td>
                                                    <td style={{ padding: '0.375rem', fontSize: '0.875rem', borderBottom: '1px solid #ddd' }}>{customerEmail}</td>
                                                    <td style={{ padding: '0.375rem', fontSize: '0.875rem', borderBottom: '1px solid #ddd' }}>{customerPhone}</td>
                                                    <td style={{ padding: '0.375rem', fontSize: '0.875rem', borderBottom: '1px solid #ddd' }}>{customerBank}</td>
                                                    <td style={{ padding: '0.375rem', fontSize: '0.875rem', borderBottom: '1px solid #ddd' }}>{customerProgram}</td>
                                                    <td style={{ padding: '0.375rem', fontSize: '0.875rem', borderBottom: '1px solid #ddd' }}>{v2PRMEmail}</td>
                                                    <td style={{ padding: '0.375rem', fontSize: '0.875rem', borderBottom: '1px solid #ddd' }}>{hdfcrm}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className='mt-5'>
                                        <h2 className='text-center text-xl fs-title '>Company Details</h2>

                                        <div className='mt-4 border border-collapse rounded-md shadow-sm'>
                                            <table className=" w-full">
                                                <tr className="border-b">
                                                    <td className="w-full sm:w-1/4 p-2" align="left">
                                                        <label className="">Trade Name : </label>
                                                    </td>
                                                    <td className="p-2 text-sm" align="left">{tradeName}</td>
                                                </tr>
                                                <tr className="border-b">
                                                    <td className="w-full sm:w-1/4 p-2" align="left">
                                                        <label className="">Legal Name : </label>
                                                    </td>
                                                    <td className="p-2 text-sm" align="left">{legalName}</td>
                                                </tr>
                                                <tr className="border-b">
                                                    <td className="w-full sm:w-1/4 p-2" align="left">
                                                        <label className="">GSTIN : </label>
                                                    </td>
                                                    <td className="p-2 text-sm" align="left">{gstin}</td>
                                                </tr>
                                                <tr className="border-b">
                                                    <td className="w-full sm:w-1/4 p-2" align="left">
                                                        <label className="">Address : </label>
                                                    </td>
                                                    <td className="p-2 text-sm" align="left">{address}</td>
                                                </tr>
                                                <tr className="border-b">
                                                    <td className="w-full sm:w-1/4 p-2" align="left">
                                                        <label className="">Business Type : </label>
                                                    </td>
                                                    <td className="p-2 text-sm" align="left">{businessType}</td>
                                                </tr>
                                                <tr className="border-b">
                                                    <td className="w-full sm:w-1/4 p-2" align="left">
                                                        <label className="">GSTIN Status : </label>
                                                    </td>
                                                    <td className="p-2 text-sm" align="left">{gstinStatus}</td>
                                                </tr>
                                                <tr className="border-b">
                                                    <td className="w-full sm:w-1/4 p-2" align="left">
                                                        <label className="">PAN : </label>
                                                    </td>
                                                    <td className="p-2 text-sm" align="left">
                                                        {pan}
                                                    </td>
                                                </tr>
                                                <tr className="border-b">
                                                    <td className="w-full sm:w-1/4 p-2" align="left">
                                                        <label className="">PAN Holder : </label>
                                                    </td>
                                                    <td className="p-2 text-sm" align="left">{panLastName}</td>
                                                </tr>
                                                <tr className="border-b">
                                                    <td className="w-full sm:w-1/4 p-2" align="left">
                                                        <label className="">PAN Status : </label>
                                                    </td>
                                                    <td className="p-2 text-sm" align="left">{panStatus}</td>
                                                </tr>
                                                {/* <tr className="border-b">
                                                    <td className="w-full sm:w-1/4 p-2" align="left">
                                                        <label className="">
                                                            Is Tax Payment Type SEZ Unit :
                                                        </label>
                                                    </td>
                                                    <td className="p-2 text-sm" align="left">{details?.result.sez === false || details?.result.sez === null ? 'No' : 'Yes'}</td>
                                                </tr> */}
                                            </table>
                                        </div>


                                    </div>
                                    <div className='mt-5'>
                                        <h2 className='text-center text-xl fs-title '>Customer Bank Details</h2>

                                        <div className='mt-4 border border-collapse rounded-md shadow-sm'>
                                            <table className=" w-full">
                                                <tr className="border-b">
                                                    <td className="w-full sm:w-1/4 p-2" align="left">
                                                        <label className="">Bank Name : </label>
                                                    </td>
                                                    <td className="p-2 text-sm" align="left">{details?.result?.customerBankDetails?.bankName}</td>
                                                </tr>
                                                <tr className="border-b">
                                                    <td className="w-full sm:w-1/4 p-2" align="left">
                                                        <label className="">Account Number : </label>
                                                    </td>
                                                    <td className="p-2 text-sm" align="left">{maskedAccount}</td>
                                                </tr>
                                                <tr className="border-b">
                                                    <td className="w-full sm:w-1/4 p-2" align="left">
                                                        <label className="">IFSC : </label>
                                                    </td>
                                                    <td className="p-2 text-sm" align="left">{details?.result?.customerBankDetails?.ifsc}</td>
                                                </tr>
                                                <tr className="border-b">
                                                    <td className="w-full sm:w-1/4 p-2" align="left">
                                                        <label className="">Accout Holder Name : </label>
                                                    </td>
                                                    <td className="p-2 text-sm" align="left">{details?.result?.customerBankDetails?.accountName}</td>
                                                </tr>
                                                <tr className="border-b">
                                                    <td className="w-full sm:w-1/4 p-2" align="left">
                                                        <label className="">Status : </label>
                                                    </td>
                                                    <td className="p-2 text-sm" align="left">{details?.result?.customerBankDetails?.isVerified===false?<>
            <button
                                                                type="submit"
                                                                className="w-1/4 p-2 mr-2 bg-sky-600 text-white font-semibold rounded hover:bg-sky-700 focus:outline-none focus:ring focus:border-blue-300"
                                                                onClick={()=>VerifyBankDetails(details)}
                                                            >Verify again</button>
                                                    </>:"Verified"}</td>
                                                </tr>
                                            </table>
                                        </div>


                                    </div>
{showB2BIds&&(
                                        <div className='mt-5'>
                                        <h2 className='text-center text-xl fs-title '>B2B ID Details</h2>

                                        <div className='mt-4 border border-collapse rounded-md shadow-sm'>
                                            <table className="w-full">
                                                               {isSuccess && (
                                               <>
                                               <tr className="border-b-2">
                                               {entityData?.existingB2BIds && entityData?.existingB2BIds.length > 0 && entityData.existingB2BIds[0] !== entityData.newB2BId && (
    <>
      <td className="w-full sm:w-1/4 p-2" align="left">
        <label className="font-semibold">Default B2BIDs : </label>
      </td>
      <td className="p-2 text-sm text-gray-800" align="left">
        {entityData.existingB2BIds.join(", ")}
      </td>
    </>
  )}
                                                </tr>
                                                <tr className="border-b-2">
                                                    <td className="w-full sm:w-1/4 p-2" align="left">
                                                        <label className="font-semibold">New B2BID : </label>
                                                    </td>
                                                    <td className="p-2 text-sm text-gray-800" align="left">{entityData?.newB2BId}</td>
                                                </tr>
                                                </>
                                          )}
                                                <tr className="border-b-2">
                                                    <td className="w-full sm:w-1/4 p-2" align="left">
                                                        <label className="font-semibold">PAN : </label>
                                                    </td>
                                                    <td className="p-2 text-sm text-gray-800" align="left">{entityData?.pan}</td>
                                                </tr>
                                                <tr className="border-b-2">
                                                    <td className="w-full sm:w-1/4 p-2" align="left">
                                                        <label className="font-semibold">Entity Name : </label>
                                                    </td>
                                                    <td className="p-2 text-sm text-gray-800" align="left">{entityData?.entityName}</td>
                                                </tr>
                                   {isErrorMsg===true?<>
                                                <tr className="border-b-2">
                                                    <td className="w-full sm:w-1/4 p-2" align="left">
                                                        <label className="font-semibold">Error : </label>
                                                    </td>
                                                    <td className="p-2 text-sm text-red-500" align="left">
                                                                                                 {isErrorMsg?"Could not find the entity details,Please contact with V2P support team.":""}
                                                    </td>
                                                </tr>
                                   </>:''}
                                            </table>
                                        </div>


                                    </div>
)}
                                    <div className='mt-6'>
                                        <h2 className='text-center text-xl fs-title '>{containsSociety || containsLLP || containsPublic || containsPrivate || containsHindu ? "LIST OF DIRECTORS" : containsProprietor ? 'PROPRIETOR DETAILS' : 'LIST OF PARTNERS'}</h2>
                                        <div className=" overflow-x-auto mt-4 border rounded-md shadow-sm">
                                            <table className="min-w-full md:max-w-5xl lg:max-w-7xl xl:max-w-full divide-y  divide-gray-200">
                                                <thead className="bg-gray-400">
                                                    <tr>
                                                        {containsProprietor || (containsPartner && doesNotContainsLiability) || containsHindu || containsSociety ? (
                                                            <>
                                                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider w-100">
                                                                    Sr.No
                                                                </th>
                                                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider w-100">
                                                                    Name
                                                                </th>
                                                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider w-100">
                                                                    PAN
                                                                </th>
                                                            </>
                                                        ) : ''}
                                                        {containsPublic || containsPrivate || containsLLP ? (
                                                            <>
                                                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider w-100">
                                                                    Sr.No
                                                                </th>
                                                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider w-100">
                                                                    Name
                                                                </th>
                                                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider w-100">
                                                                    Designation
                                                                </th>
                                                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider w-100">
                                                                    DIN
                                                                </th>
                                                            </>
                                                        ) : ''}
                                                    </tr>
                                                </thead>
                                                <tbody className="bg-white divide-y divide-gray-200 ">
                                                    {details?.result.partners.map((partner, index) => (
                                                        <tr key={index} className="border-t">
                                                            {containsProprietor || (containsPartner && doesNotContainsLiability) || containsHindu || containsSociety ? <>
                                                                <td className="px-3 text-sm py-4 w-100 border-r">
                                                                    {index + 1}
                                                                </td>
                                                                <td className="px-3 text-sm py-4 w-100 border-r">
                                                                    {partner.partnerName}
                                                                </td>
                                                                <td className="px-3 text-sm py-4 w-100 border-r">
                                                                    {partner.partnerPAN}
                                                                </td>
                                                            </> : ''}
                                                            {containsPublic || containsPrivate || containsLLP ? (
                                                                <>
                                                                    <td className="px-3 text-sm py-4 w-100 border-r">
                                                                        {index + 1}
                                                                    </td>
                                                                    <td className="px-3 text-sm py-4 w-100 border-r">
                                                                        {partner.partnerName}
                                                                    </td>
                                                                    <td className="px-3 text-sm py-4 w-100 border-r">
                                                                        {partner.designation}
                                                                    </td>
                                                                    <td className="px-3 text-sm py-4 w-100 border-r">
                                                                        {partner.partnerPAN
                                                                        }
                                                                    </td>
                                                                </>
                                                            ) : ''}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className='mt-5'>
                                        <h2 className='text-center text-xl fs-title '>List Of Users</h2>
                                        <div className="overflow-x-auto mt-4 border rounded-md shadow-sm">
                                            {/* <table className="min-w-full md:max-w-5xl lg:max-w-7xl xl:max-w-full divide-y  divide-gray-200">
                                                <thead className="bg-gray-400">
                                                    <tr>
                                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider w-100">
                                                            Sr.No
                                                        </th>
                                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider w-100">
                                                            Name
                                                        </th>
                                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider w-100">
                                                            Email
                                                        </th>
                                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider w-100">
                                                            Phone
                                                        </th>
                                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider w-100">
                                                            Role
                                                        </th> */}
                                            {/* {details?.result.approvalStatus === 0 ? <>
                                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider w-100">
                                                                OTP Subscription
                                                            </th>
                                                        </> : null} */}
                                            {/* </tr>
                                                </thead> */}
                                            {/* <tbody className="bg-white divide-y divide-gray-200 ">
                                                    {details?.result.customerUsers.map((partner, index) => (
                                                        <tr key={index} className="border-t">
                                                            <td className="px-3 text-sm py-4 w-100 border-r">
                                                                {index + 1}
                                                            </td>
                                                            <td className="px-3 text-sm py-4 w-100 border-r">
                                                                {partner.firstName + partner.lastName}                                                            </td>
                                                            <td className="px-3 text-sm py-4 w-100 border-r">
                                                                {partner.email}
                                                            </td>
                                                            <td className="px-3 text-sm py-4 w-100 border-r">
                                                                {partner.phone}
                                                            </td>
                                                            <td className="px-3 text-sm py-4 w-100 border-r">
                                                                {partner.permissions === 'others' ? (
                                                                    <>
                                                                        {partner.selectedRoles ? (
                                                                            <>
                                                                                <span>
                                                                                    {typeof partner.selectedRoles === 'string' ? (
                                                                                        partner.selectedRoles.includes('[') ? (
                                                                                            JSON.parse(partner.selectedRoles).join(' & ')
                                                                                        ) : (
                                                                                            partner.selectedRoles.split(',').map(role => role.trim()).join(' & ')
                                                                                        )
                                                                                    ) : null}
                                                                                </span>
                                                                            </>
                                                                        ) : null}
                                                                    </>
                                                                ) : (
                                                                    <span>
                                                                        {partner.permissions.replace('_', ' & ')}
                                                                    </span>
                                                                )}
                                                            </td> */}
                                            {/* {details?.result.approvalStatus === 0 ? <>
                                                                <td className="px-3 text-sm py-4 w-100 border-r">
                                                                    {partner.selectedRoles ?
                                                                        <>
                                                                            <span>
                                                                                {typeof partner.otpSubscription === 'string' ? (
                                                                                    partner.otpSubscription.includes('[') ? (
                                                                                        JSON.parse(partner.otpSubscription).join(' & ')
                                                                                    ) : (
                                                                                        partner.otpSubscription.split(',').map(role => role.trim()).join(' & ')
                                                                                    )
                                                                                ) : null}
                                                                            </span>
                                                                        </> : null
                                                                    }
                                                                </td>
                                                            </> : null} */}
                                            {/* </tr>
                                                    ))}
                                                </tbody>
                                            </table> */}
                                            <table className=" min-w-full md:max-w-5xl lg:max-w-7xl xl:max-w-full divide-y divide-gray-200">
                                                <thead className="bg-gray-100">
                                                    <tr>
                                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2">
                                                            Sr.No
                                                        </th>
                                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2">
                                                            Name
                                                        </th>
                                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2">
                                                            Email
                                                        </th>
                                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2">
                                                            Phone
                                                        </th>
                                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2">
                                                            Role
                                                        </th>
                                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2">
                                                            Pan
                                                        </th>
                                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2">
                                                            Pan Holder
                                                        </th>
                                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2">
                                                            Name at Bank
                                                        </th>
                                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2">
                                                            Aadhar Status
                                                        </th>
                                                        {/* <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2">
                                                            Mobile Number
                                                        </th>
                                                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2">
                                                            Gender
                                                        </th> */}
                                                    </tr>
                                                </thead>
                                                <tbody className="bg-white divide-y divide-gray-200">
                                                    {details?.result.customerUsers.map((partner, index) => (
                                                        <tr key={index} className="border-t">
                                                            <td className="px-3 text-sm py-4 border-r">
                                                                {index + 1}
                                                            </td>
                                                            <td className="px-3 text-sm py-4 border-r">
                                                                {partner.firstName} {partner.lastName}
                                                            </td>
                                                            <td className=" px-3 text-sm py-4 border-r">
                                                                {partner.email}
                                                            </td>
                                                            <td className="px-3 text-sm py-4 border-r">
                                                                <span className="flex justify-center">
                                                                    {partner.phone}
                                                                    {partner.isPhoneMatch === true ? <>
                                                                        <button title={partner.nameOnPhone}>
                                                                            <svg style={{ marginTop: '-2px', marginLeft: '2px' }} color="green" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                                                            </svg>
                                                                        </button>
                                                                    </> : <>
                                                                        <button title={partner.nameOnPhone}>
                                                                            <svg style={{ marginTop: '-2px', marginLeft: '2px' }} color="red" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" className="w-4 h-4">
                                                                                <path fillRule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM8 4a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3A.75.75 0 0 1 8 4Zm0 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" clipRule="evenodd" />
                                                                            </svg>
                                                                        </button>
                                                                    </>}
                                                                </span>
                                                            </td>
                                                            <td className="px-3 text-sm py-4  border-r">
                                                                {partner.permissions === 'others' ? (
                                                                    <>
                                                                        {partner.selectedRoles ? (
                                                                            <>
                                                                                <span>
                                                                                    {typeof partner.selectedRoles === 'string' ? (
                                                                                        partner.selectedRoles.includes('[') ? (
                                                                                            JSON.parse(partner.selectedRoles).join(' & ')
                                                                                        ) : (
                                                                                            partner.selectedRoles.split(',').map(role => role.trim()).join(' & ')
                                                                                        )
                                                                                    ) : null}
                                                                                </span>
                                                                            </>
                                                                        ) : null}
                                                                    </>
                                                                ) : (
                                                                    <span>
                                                                        {partner.permissions.replace('_', ' & ')}
                                                                    </span>
                                                                )}
                                                            </td>
                                                            <td className="px-3 text-sm py-4  border-r">
                                                                <span className="flex justify-center">
                                                                    {partner.pan || ''}
                                                                    {partner.isPanMatch === true ? <>
                                                                        <button title={partner.nameOnPan}>
                                                                            <svg style={{ marginTop: '-2px', marginLeft: '2px' }} color="green" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                                                            </svg>
                                                                        </button>
                                                                    </> : <>
                                                                        <button title={partner.nameOnPan}>
                                                                            <svg style={{ marginTop: '-2px', marginLeft: '2px' }} color="red" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" className="w-4 h-4">
                                                                                <path fillRule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM8 4a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3A.75.75 0 0 1 8 4Zm0 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" clipRule="evenodd" />
                                                                            </svg>
                                                                        </button>
                                                                    </>}
                                                                </span>
                                                            </td>
                                                            <td className=" px-3 text-sm py-4 border-r">
                                                                {partner.nameOnPan}
                                                            </td>
                                                            <td className=" px-3 text-sm py-4 border-r">
                                                                {partner.nameOnPhone}
                                                            </td>
                                                            <td className=" px-3 text-sm py-4 border-r">
                                                                {partner.aadhaar===null?"Not Provided":partner.aadhaarStatus}
                                                            </td>
                                                            {/* <td className=" px-3 text-sm py-4 border-r">
                                                                {partner.aadhaarPhoneNumber}
                                                            </td>
                                                            <td className=" px-3 text-sm py-4 border-r">
                                                                {partner.gender}
                                                            </td> */}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
 

  <div style={{ overflowX: "auto", paddingTop: "20px" }}>
                                            <h2 className='text-center text-xl fs-title mb-4 mt-3'>AML PEP Report</h2>
  <table style={{ width: "100%", borderCollapse: "collapse", border: "1px solid #003366" }}>
    <thead style={{ backgroundColor: "#003366", color: "white" }}>
      <tr>
        <th style={{ border: "1px solid #003366", padding: "8px", textAlign: "left" }}>Elements</th>
        <th style={{ border: "1px solid #003366", padding: "8px", textAlign: "left" }}>Details</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style={{ border: "1px solid #003366", padding: "8px" }}>
          Over 1,600,000 politically exposed entities from 250+ countries and territories
        </td>
        <td style={{ border: "1px solid #003366", padding: "8px" }}>
          {details?.result?.rubixReportData?.pep_list||"null"}
        </td>
      </tr>
      <tr>
        <td style={{ border: "1px solid #003366", padding: "8px" }}>
          All government sanction lists (OFAC, EU Terror List, United Nations, Bank of England, etc.)
        </td>
        <td style={{ border: "1px solid #003366", padding: "8px" }}>
          {details?.result?.rubixReportData?.sanction_list||"null"}
        </td>
      </tr>
      <tr>
        <td style={{ border: "1px solid #003366", padding: "8px" }}>
          Over 20 Embargo and caution lists (FBI, World Bank, Interpol, etc.)
        </td>
        <td style={{ border: "1px solid #003366", padding: "8px" }}>
          {details?.result?.rubixReportData?.watch_list||"null"}
        </td>
      </tr>
      <tr>
        <td style={{ border: "1px solid #003366", padding: "8px" }}>
          Enforcement, Embargo and Denied Parties Lists (Security and Exchange Commissions, State Attorney warnings and Central Bank notices, etc.)
        </td>
        <td style={{ border: "1px solid #003366", padding: "8px" }}>
          {details?.result?.rubixReportData?.enforcement_list||"null"}
        </td>
      </tr>
      <tr>
        <td style={{ border: "1px solid #003366", padding: "8px" }}>
          Over 15,000 sources, such as digital media, newspapers, periodicals, wikis, blogs, press releases, podcasts, etc.
        </td>
        <td style={{ border: "1px solid #003366", padding: "8px" }}>
          {details?.result?.rubixReportData?.adverse_media||"null"}
        </td>
      </tr>

      {details?.result?.rubixReportData?.error_Message && (
        <tr>
          <td style={{ border: "1px solid #003366", padding: "8px", fontWeight: "bold", color: "red" }}>
            Error
          </td>
          <td style={{ border: "1px solid #003366", padding: "8px", color: "red" }}>
            {details?.result?.rubixReportData?.error_Message}
          </td>
        </tr>
      )}
            {details?.result?.rubixReportData?.status==="PENDING" && (
        <tr>
          <td style={{ border: "1px solid #003366", padding: "8px", fontWeight: "bold", color: "red" }}>
            Status
          </td>
          <td style={{ border: "1px solid #003366", padding: "8px", color: "red" }}>
            Report generation is in progress
          </td>
        </tr>
      )}
            {details?.result?.rubixReportData?.status==="COMPLETED" && (
        <tr>
          <td style={{ border: "1px solid #003366", padding: "8px", fontWeight: "bold", color: "#003366" }}>
            Report Source
          </td>
          <td style={{ border: "1px solid #003366", padding: "8px", color: "blue" ,cursor:'pointer'}}>
    <a
      href={details?.result?.rubixReportData?.report_Url}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#003366"}}
    >Click here to see the full report</a>
          </td>
        </tr>
      )}
    </tbody>
  </table>
</div>

    {showSellerSelect && (
        <div className="grid mt-6 sm:grid-cols-12 gap-4">
        <div className="sm:col-span-12 md:col-span-4">
            <select
                id="sellerSelect"
                value={selectedSeller}
                onChange={handleSellerChange}
                disabled={details?.result.approvalStatus === 1 ? true : false}
                className="w-full p-2 border border-gray-300 rounded mt-6"
            >
                <option value="">Select Seller</option>
                {sellerData?.map((seller) => (
                    <option key={seller.sellerId} value={seller.sellerId}>
                        {seller.sellerName}
                    </option>
                ))}
            </select>
        </div>
        </div>
    )}
                                    <div className="grid mt-6 sm:grid-cols-12 gap-4">
                                        <div className="sm:col-span-12 md:col-span-4">
                                            <select
                                                name="bt"
                                                id="CustomerDetailBusinessType"
                                                required
                                                disabled={details?.result.approvalStatus === 1 ? true : false}
                                                value={handleInitialBusinessTypeValue()}
                                                onChange={handleChange}
                                                className="w-full p-2 border border-gray-300 rounded"
                                            >
                                                <option value=''>Select Business Type</option>
                                                {businessTypes?.map((businessType) => (
                                                    <option key={businessType.id} value={businessType.id}>
                                                        {businessType.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        {details?.result.approvalStatus === 1 ? null : <>
                                            <div className="flex sm:col-span-12 md:col-span-6">
                                                {
                                                    (details?.result.programId === 1 || details?.result.programId === 2 || details?.result.programId === 3 || details?.result.programId === 4) && (details?.result.isAgreementReceived == null || details?.result.isAgreementReceived === 0 || details?.result.isAgreementReceived === false) ?
                                                        <>
                                                            <button
                                                                type="submit"
                                                                // disabled={details?.result.businessTypeId === null ? true : false}
                                                                className="w-1/2 p-2 mr-2 bg-sky-600 text-white font-semibold rounded hover:bg-sky-700 focus:outline-none focus:ring focus:border-blue-300"
                                                                onClick={getAgreementDataCall}
                                                            >Agreement Recieved</button>
                                                        </> : <>
                                                            <button
                                                                type="submit"
                                                                className="w-1/2 p-2 mr-2 bg-sky-600 text-white font-semibold rounded hover:bg-sky-700 focus:outline-none focus:ring focus:border-blue-300"
                                                                onClick={handleApprove}
                                                            >Approve</button>
                                                        </>
                                                }
                                                <button
                                                    className="w-1/2 text-center bg-gray-500 text-white p-2 font-semibold rounded hover:bg-gray-400 focus:outline-none focus:ring focus:border-red-300"
                                                    onClick={handleRejection}
                                                >Reject</button>
                                            </div>
                                        </>}
                                        <Transition
                                            as={Fragment}
                                            show={isModalOpen}
                                            enter="ease-out duration-300"
                                            enterFrom="opacity-0"
                                            enterTo="opacity-100"
                                            leave="ease-in duration-200"
                                            leaveFrom="opacity-100"
                                            leaveTo="opacity-0"
                                        >
                                            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity">
                                                <div className="fixed inset-0 z-10 overflow-y-auto">
                                                    <div className="flex items-center justify-center min-h-full p-4 sm:p-0">
                                                        <Transition
                                                            as={Fragment}
                                                            enter="ease-out duration-300"
                                                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                                                            leave="ease-in duration-200"
                                                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                                        >
                                                            <div className="relative transform overflow-hidden rounded-lg text-left transition-all w-full max-w-2xl sm:max-w-3xl h-auto">
                                                                <form
                                                                    onSubmit={rejectCustomer}
                                                                >
                                                                    <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                                                                        <div className="sm:flex sm:items-start">
                                                                            <div className=" w-full sm:text-left">
                                                                                <div>
                                                                                    <div className="grid grid-cols-12 gap-2">
                                                                                        <div className="col-span-12">
                                                                                            <label className="block mb-2 text-md font-medium leading-6 text-gray-900">Rejection Reason :</label>
                                                                                            <input
                                                                                                type="text"
                                                                                                name="rejection_reason"
                                                                                                placeholder="Enter reason"
                                                                                                required
                                                                                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                                                                value={rejectReason}
                                                                                                onChange={handleChangeRejectReason}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                                                        <button type="submit" className="inline-flex w-full justify-center rounded-md bg-sky-700 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-sky-700 sm:ml-3 sm:w-auto">Proceed</button>
                                                                        <button type="button" className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto" onClick={() => setIsModalOpen(false)}>Cancel</button>
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </Transition>
                                                    </div>
                                                </div>
                                            </div>
                                        </Transition>

                                    </div>
                                    {details?.result.approvalStatus === 2 && <>
                                        {rejectionEntries?.value.length !== 0 ? <>
                                            <div className='overflow-x-auto mt-4 border rounded-md shadow-sm shadow-sm'>
                                                <table
                                                    className="min-w-full md:max-w-5xl lg:max-w-7xl xl:max-w-full divide-y  divide-gray-200"                                     >
                                                    <thead className="bg-gray-400">
                                                        <tr>
                                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider w-100">Sr.No.</th>
                                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider w-100">Reason</th>
                                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider w-100">Rejected By</th>
                                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider w-100">Rejected at</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="bg-white divide-y divide-gray-200 ">
                                                        {rejectionEntries?.value.map((entry, index) => (
                                                            <tr className='border-t' key={entry.id}>
                                                                <td className="px-3 text-sm py-4 w-100 border-r">{index + 1}</td>
                                                                <td className="px-3 text-sm py-4 w-100 border-r">{entry.rejectionReason}</td>
                                                                <td className="px-3 text-sm py-4 w-100 border-r">{entry.fullName + "_" + entry.email}</td>
                                                                <td className="px-3 text-sm py-4 w-100 border-r">{formatDate(entry.rejectedAt)}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </> : <></>}
                                    </>}
                                </div>
                            </div>
                            <div className=" col-span-12 md:col-span-1 lg:col-span-1"></div>
                        </div>
                    </div >
                </LogoDiv >
            </body >
        </>
    )
}

export default Details
